export const toSet = (source) => {
    return new Set(source);
};
